// ui
import { Button, Typography, Modal, Box, Alert } from "@mui/material";
import PersonOffIcon from "@mui/icons-material/PersonOff";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../../lib/store";
import { useWindowSize } from "../../lib/useWindowSize";

interface PersonDataDeleteModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  deletePersonDataInf: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  };
  setDeletePersonDataInf: (value: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }) => void;
  deletePersonData: () => void;
}

export function PersonDataDeleteModal(props: PersonDataDeleteModalProps) {
  const {
    onModal,
    swCloseModal,
    deletePersonDataInf,
    setDeletePersonDataInf,
    deletePersonData,
  } = props;
  const { windowWidth, windowHeight } = useWindowSize();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 568 ? "500px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} data-testid="person-data-delete-modal">
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="deleteTitleBox"
          className="shippori-antique-regular"
        >
          個人情報削除
        </Box>
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
          {deletePersonDataInf.status === "open" ? (
            <>
              <Alert severity="error">
                個人情報削除後、データは復元できません。
              </Alert>
              <Box style={{ display: windowWidth > 385 ? "flex" : undefined }}>
                <Box
                  style={{
                    marginTop: "10px",
                    height: "40px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: windowWidth > 385 ? undefined : "5px",
                    textTransform: "none",
                  }}
                >
                  <Button
                    data-testid="person-data-delete-execute-button"
                    style={{
                      height: "40px",
                      width: "100%",
                    }}
                    variant="contained"
                    onClick={deletePersonData}
                  >
                    <Box className="m-plus-rounded-1c-regular">
                      個人情報削除
                    </Box>
                    <PersonOffIcon
                      sx={{ marginLeft: "6px", color: "white" }}
                      fontSize="medium"
                    />
                  </Button>
                </Box>
                <Box
                  style={{
                    marginTop: "10px",
                    height: "40px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: windowWidth > 385 ? "10px" : "5px",
                    textTransform: "none",
                  }}
                >
                  <Button
                    data-testid="person-data-delete-close-button"
                    variant="contained"
                    style={{
                      height: "40px",
                      width: "100%",
                    }}
                    onClick={swCloseModal}
                  >
                    <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                  </Button>
                </Box>
              </Box>
            </>
          ) : deletePersonDataInf.status === "success" ? (
            <>
              <Box className="shippori-antique-regular">
                個人情報の削除に成功しました。
              </Box>
              <Box>
                <Button
                  data-testid="person-data-delete-success-close-button"
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={swCloseModal}
                >
                  <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                </Button>
              </Box>
            </>
          ) : deletePersonDataInf.status === "failed" ? (
            <>
              <Box className="shippori-antique-regular">
                {deletePersonDataInf.message}
              </Box>
              <Box>
                <Button
                  data-testid="person-data-delete-retry-button"
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={() =>
                    setDeletePersonDataInf({
                      ...deletePersonDataInf,
                      status: "open",
                      message: "",
                    })
                  }
                >
                  <Box className="m-plus-rounded-1c-regular">戻る</Box>
                </Button>
              </Box>
            </>
          ) : null}
        </Typography>
      </Box>
    </Modal>
  );
}
